import React, { Component } from 'react';
import styles from "./DotLoaderStyles.module.scss";
import { IMAGES } from "constants/constants"

class DotLoader extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <>
                <img src={IMAGES.SHARED.GCLogoWhite} className={styles.logo } alt="GameCity Logo" />
                <div className={`${styles.dotLoader} ${styles[this.props.size] || styles.medium} ${styles.light}`}>
                    <span className={styles.dot}></span>
                    <span className={styles.dot}></span>
                    <span className={styles.dot}></span>
                </div>
            </>
        );
    }
}

export default DotLoader;

